import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlHandlingStrategy } from '@angular/router';
import { EmptyComponent } from './empty/empty.component';
import { CustomUrlHandlingStrategy } from './custom.url-handling-strategy';

const routes: Routes = [{ path: '**', component: EmptyComponent }];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [{ provide: UrlHandlingStrategy, useClass: CustomUrlHandlingStrategy}]
})
export class AppRoutingModule { }
